import { render } from "./Groups.vue?vue&type=template&id=4319a7c4"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
script.render = render

export default script